import type { OpenLoginRegisterPopupOptions } from "./LoginRegisterPopup.types";

export const LOGIN_REGISTER_POPUP_EVENT = "show-login-register-popup";
export const CLOSE_LOGIN_REGISTER_POPUP_EVENT = "close-login-register-popup";

export const openLoginRegisterPopup = (
  options?: OpenLoginRegisterPopupOptions
) => {
  window.dispatchEvent(
    new CustomEvent(LOGIN_REGISTER_POPUP_EVENT, {
      detail: options || {},
    })
  );
};

export const closeLoginRegisterPopup = () => {
  window.dispatchEvent(new CustomEvent(CLOSE_LOGIN_REGISTER_POPUP_EVENT));
};
